export default "__VITE_ASSET__DCT5MMG8__"